import { Box } from '@global-engineering-shared/gweb-material-ui';

import EntityListTable from 'components/EntityListTable';
import useStyles from 'components/EntityListTable/components/TableContainer/TablesContainer.styles';
import { ITableConfig } from 'components/Table/types/table';
import PaginatedItemsProvider from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import SelectedEntitiesProvider from 'context/SelectedEntities/SelectedEntitiesProvider';
import { addFiltersToUrl } from 'utils/addFiltersToUrl';
import { DEFAULT_TABLE_PAGE_SIZE } from 'utils/defaults';

interface ITableContainerProps {
  tablesConfig: ITableConfig[];
  tableHeader?: React.ReactNode;
}

const TableContainer: React.FC<ITableContainerProps> = ({ tablesConfig, tableHeader }) => {
  const { searchParams } = useSearchParamsProvider();
  const classes = useStyles();

  return (
    <>
      <Box className={classes.tableContainer}>
        {tablesConfig.map((tableConfig: ITableConfig, index: number) => {
          const url = addFiltersToUrl(tableConfig.url, searchParams);
          const tableContent = (
            <PaginatedItemsProvider
              key={'paginatedItemsIndex ' + index}
              pageableUrl={url}
              startingPageSize={DEFAULT_TABLE_PAGE_SIZE}
              pageSize={DEFAULT_TABLE_PAGE_SIZE}
              refreshKey={tableConfig.refreshToggle}
            >
              {index === 0 && tableHeader}
              <EntityListTable tableConfig={tableConfig} id={'id ' + index} />
            </PaginatedItemsProvider>
          );

          return tableConfig.hasCheckboxes ? (
            <SelectedEntitiesProvider key={'selectedEntitiesIndex ' + index}>
              {tableContent}
            </SelectedEntitiesProvider>
          ) : (
            tableContent
          );
        })}
      </Box>
    </>
  );
};

export default TableContainer;
